





































































import {
  SfButton,
  SfLoader
} from '@storefront-ui/vue';
import { defineComponent, ref, onMounted, onBeforeUnmount, computed, provide } from '@nuxtjs/composition-api';
import { getFilterConfig } from '@wemade-vsf/catalog/lib/runtime/category/config/FiltersConfig';
import { useSearch } from '@wemade-vsf/search';
import { useUiHelpers } from '@wemade-vsf/composables';
import { useFacet } from '@wemade-vsf/catalog/lib/runtime/category/composables/useFacet';
import ProductCard from 'components/catalog/Product/ProductCard.vue'
import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
import { Aggregation, AggregationOption } from '@wemade-vsf/magento-api';

export default defineComponent({
  name: 'SearchResults',
  components: {
    ProductCard,
    CheckboxType: () => import('components/catalog/Category/Filters/Renderer/CheckboxType.vue'),
    SwatchType: () => import('components/catalog/Category/Filters/Renderer/SwatchType.vue'),
    RadioType: () => import('components/catalog/Category/Filters/Renderer/RadioType.vue'),
    YesNoType: () => import('components/catalog/Category/Filters/Renderer/YesNoType.vue'),
    RangeType: () => import('components/catalog/Category/Filters/Renderer/RangeType.vue'),
    SfButton,
    SfLoader
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: [Number, String],
      default: 3
    }
  },
  setup () {
    const { searchResults, loading, changeFilter, selectedAggregations, closeSearch, nextPage: loadNextPage } = useSearch();
    const searchContainer = ref(null)

    onMounted(() => {
      if (!process.server && searchContainer.value) lock(searchContainer.value)
    })
    onBeforeUnmount(() => {
      if (!process.server && searchContainer.value) clearBodyLocks();
    })

    const aggregations = computed(() => searchResults.value?.aggregations?.filter(a => a.attribute_code !== 'category_id'))

    const categoryFilter = computed(() => searchResults.value?.aggregations
      ? searchResults.value.aggregations.find(a => a?.attribute_code === 'category_uid')
      : null);

    const isFilterSelected = (code: string, value: string) => {
      return selectedAggregations.value?.[code]?.includes(value)
    }

    const selectFilter = (filter: Aggregation, option: AggregationOption) => {
      changeFilter(filter.attribute_code, option.value)
    }

    const { getFacetsFromURL } = useUiHelpers();
    const { loadMoreAggregationOptions } = useFacet();

    const loadMoreOptions = async (attributeCode) => {
      const aggIndex = searchResults.value?.aggregations?.findIndex(a => a.attribute_code === attributeCode);
      if (!aggIndex) return
      //@ts-ignore
      let result = await loadMoreAggregationOptions(attributeCode, getFacetsFromURL());
      if (result && searchResults.value?.aggregations) {
        let currentAggregations = searchResults.value.aggregations;
        currentAggregations.splice(aggIndex, 1, result)
        searchResults.value.aggregations = currentAggregations;
      }
    }

    const productsLeft = computed(() => {
      if (!searchResults.value?.total_count
        || !searchResults.value.page_info?.page_size
        || !searchResults.value.page_info?.current_page
        ) return 0;
      const leftProducts = searchResults.value.total_count - (searchResults.value.page_info.current_page * searchResults.value.page_info.page_size);
      return leftProducts > 0 ? leftProducts : 0;
    })

    provide('UseAggregationProvider', { loadMoreOptions })

    provide('UseFiltersProvider', { isFilterSelected, selectedFilters: selectedAggregations, filters: aggregations });

    return {
      searchResults,
      searchContainer,
      aggregations,
      categoryFilter,
      selectedAggregations,
      selectFilter,
      isFilterSelected,
      getFilterConfig,
      closeSearch,
      productsLeft,
      loading,
      loadNextPage
    }
  }
});
